import React, { Component, Fragment } from 'react';
import * as Func from '../../../helpers/functions';
import { Link, Route, withRouter } from 'react-router-dom';
import action from '../../../actions/index';
import { connect } from "react-redux";
import routes from '../../../routers';
import { withTranslation } from 'react-i18next';
import { Icon, Menu, Button, Drawer, Avatar } from 'antd';
import i18n from '../../../constants/initLng';
// import ImageUrls from '../../../constants/Images';
// import Image from './../common/component/Image';
import DEFINE, { PATHS } from "../../../constants/Define";
import Images from "../../../constants/Images";
import { getLocaleFullName } from "../../../utils/commonUtils";

import $ from 'jquery'
import { isMobile } from 'react-device-detect';
import { debounce } from 'lodash';
import ButtonCollapseMenu from './../common/component/ButtonCollapseMenu';
import Modal from './../common/component/Modal';
import Ripple from './component/Ripple';
import './Navigation.less';
import FontIcon, { SolidIcons } from './component/FontIcon';
import LanguageSelect from '../modules/LanguageSelect';
import EllipsisText from './component/EllipsisText';
import Wrapper from './component/Wrapper';

const { SubMenu } = Menu;

// const isMobile = window.innerWidth <= 500;

class Navigation extends Component {

    state = {
        pageMenu: 'home',
        subMenu: [],
        subMenuActive: undefined,
    };

    componentDidMount() {
        this.setMenu(this.props)
    }

    componentWillReceiveProps(props) {
        this.setMenu(props);
    }

    setMenu = (props) => {
        if (props.menuActive) {
            let newMenuActive = props.menuActive;
            var result = routes.map(value =>
                value.children && value.children.map(child => Object.assign({ parent: value.path }, child))
            ).reduce((l, n) => l.concat(n), []);
            result = Func.removeElementNull(result);
            result.map((i, k) => {
                if (i[k + 1].path === props.menuActive) {
                    newMenuActive = i[k + 1].parent;
                }
            });
            let itemRoute = Func.FindIteminArrayRecursive(routes, props.menuActive);
            if (itemRoute.item?.tagSub) {
                routes.map(i => {
                    if (i?.tagSub) {
                        if (i?.tagSub === itemRoute.item?.tagSub) {
                            i.children && i.children.length > 0 && i.children.map(i2 => {
                                if (i2.group === itemRoute.item.group) {
                                    newMenuActive = i2.path;
                                }
                            })
                        }
                    }
                });
            }
            this.setState({
                subMenu: !this.props.collapsedMenuLeft && itemRoute.item?.tagSub ? [itemRoute.item?.tagSub] : [],
                pageMenu: newMenuActive,
            });
        }
    }

    onClose = () => {
        this.props.toggleCollapsedMenuLeft(true)
    };

    changeMenu = (e) => {
        this.setState({
            pageMenu: e.key,
        });
    };

    onOpenChange = (e) => {
        this.setState({
            subMenu: e,
        });
    };

    onLogoutRequest = () => {
        const { t } = this.props;
        const { confirm } = Modal;
        confirm({
            title: t(`notification.sureLogout`),
            okText: t(`logout`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                this.props.onLogoutRequest();
            },
        });
    };

    onPressChangePassword = () => {
        this.props.history.push(PATHS.PROFILE.path)
    }

    render() {
        const { isAdmin, dataUser } = this.props;
        const { pageMenu, subMenu } = this.state;
        return (
            <nav className={`${this.props.collapsedMenuLeft ? 'menu-left-collapsed' : 'col-md-2'} menuLeft`} role="navigation" style={{ width: isMobile && 'unset' }}>
                {
                    isMobile ? (
                        <NavigationMobile collapsedMenuLeft={this.props.collapsedMenuLeft} onClose={this.onClose}>
                            <NavigationMenu collapsedMenuLeft={false} t={this.props.t} changeMenu={this.changeMenu}
                                isAdmin={isAdmin}
                                menuActive={this.props.menuActive}
                                subMenu={subMenu}
                                onOpenChange={this.onOpenChange}
                                pageMenu={pageMenu}
                                permissions={this.props.permissions} />
                        </NavigationMobile>
                    ) : (
                            <NavigationMenu t={this.props.t} collapsedMenuLeft={this.props.collapsedMenuLeft}
                                isAdmin={isAdmin}
                                menuActive={this.props.menuActive}
                                subMenu={subMenu}
                                onOpenChange={this.onOpenChange}
                                changeMenu={this.changeMenu} pageMenu={pageMenu}
                                permissions={this.props.permissions}
                                dataUser={dataUser}
                                currentLanguage={this.props.settingState.contentLanguage}
                                onPressCollapse={() => this.props.toggleCollapsedMenuLeft(this.props.collapsedMenuLeft)}
                                onPressChange={this.onPressChangePassword}
                                onChangeLanguage={this.props.changeContentLanguage}
                                onPressLogout={this.onLogoutRequest} />
                        )
                }
            </nav>
        );
    }
}

const NavigationMenu = props => {
    const { dataUser } = props;
    const itemRoute = Func.FindIteminArrayRecursive(routes, props.menuActive);
    const onOpenChange = (e) => {
    };
    const renderNavMenuContent = (route, title, collapsed) => <Fragment>
        {route.icon && route.icon.startsWith('fa')
            ? <Icon component={() => <FontIcon icon={SolidIcons[route.icon]} style={{ fontSize: 14, width: 14, height: 14, color: 'rgb(0,0,0, 0.65)' }} />} />
            : <Icon type={route.icon} />
        }
        <span>{title}</span>
    </Fragment>

    return (
        <div className={`navigation ${props.collapsedMenuLeft ? 'collapsed' : ''}`}>
            <div className={`navigation-logo text-center ${props.collapsedMenuLeft ? 'collapsed' : ''}`}>
                {props.collapsedMenuLeft ?
                    <Ripple className="cursorPointer" onClick={props.onPressCollapse}>
                        <img src={Images.icon} className="img-fluid mb-0 mt-1" width={24} height={24} />
                    </Ripple> :
                    <Link to={`/`}>
                        <Ripple><img src={Images.logo} className="img-fluid mt-2" /></Ripple>
                    </Link>
                }
                {!props.collapsedMenuLeft && !isMobile &&
                    <div className="collapsed-btn-absolute">
                        <ButtonCollapseMenu size={16} onClick={props.onPressCollapse} />
                    </div>
                }
            </div>
            <div className={`navigation-menu ${!props.collapsedMenuLeft && !isMobile ? 'pl-15' : ''}`}>
                <Menu
                    openKeys={props.subMenu}
                    selectedKeys={[props.pageMenu]}
                    onClick={props.changeMenu}
                    onOpenChange={props.onOpenChange}
                    mode="inline"
                    inlineCollapsed={props.collapsedMenuLeft}
                    inlineIndent={30}
                    style={{ border: 'none' }}
                >

                    {
                        routes.map((route) => {
                            let title = props.t('navigation.' + [route.title]);
                            if (route.show) {
                                if (!route?.tagSub) {
                                    let viewMenuName = `${route.routeName}.${DEFINE.GENERAL.PERMISSION.VIEW}`;
                                    if (props.permissions && props.permissions.length > 0 && (props.permissions.includes(viewMenuName) || route.developing)) {
                                        return (
                                            <Menu.Item key={route.path}>
                                                <Route path={route.path} exact={route.exact} children={({ match }) => {
                                                    return (
                                                        <Link to={{
                                                            pathname: route.path,
                                                            state: { title: title }
                                                        }}>
                                                            {renderNavMenuContent(route, title, props.collapsedMenuLeft)}
                                                        </Link>
                                                    );
                                                }} />
                                            </Menu.Item>
                                        )
                                    }
                                } else {
                                    let isActiveSubMenu = false;
                                    const subMenuItems = route.children.map((subRoute) => {
                                        let title = props.t('navigation.' + [subRoute.title]);
                                        if (subRoute.show) {
                                            let viewMenuName = `${subRoute.routeName}.${DEFINE.GENERAL.PERMISSION.VIEW}`;
                                            if (props.permissions && props.permissions.length > 0 && (props.permissions.includes(viewMenuName) || route.developing || subRoute.developing)) {
                                                isActiveSubMenu = true;
                                                return (
                                                    <Menu.Item key={subRoute.path}>
                                                        <Route path={subRoute.path} exact={subRoute.exact} children={({ match }) => {
                                                            return (
                                                                <Link to={{
                                                                    pathname: subRoute.path,
                                                                    state: { title: title }
                                                                }}>
                                                                    {renderNavMenuContent(subRoute, title, props.collapsedMenuLeft)}
                                                                </Link>
                                                            );
                                                        }} />
                                                    </Menu.Item>
                                                )
                                            }

                                        }
                                    })
                                    return (
                                        <SubMenu className={`sub-menu-${route?.tagSub}`} style={{ display: isActiveSubMenu ? undefined : 'none' }}
                                            key={route?.tagSub}
                                            title={
                                                <span>
                                                    {renderNavMenuContent(route, title, props.collapsedMenuLeft)}
                                                </span>
                                            }
                                        >
                                            {subMenuItems}
                                        </SubMenu>
                                    );
                                }
                            }
                        })
                    }
                </Menu>
                <div className="navigation-menu-space"></div>
            </div>
            {!isMobile &&
                <div className={`navigation-footer ${props.collapsedMenuLeft ? 'collapsed' : ''}`}>
                    {!!props.onChangeLanguage &&
                        <LanguageSelect
                            collapsed={props.collapsedMenuLeft}
                            current={props.currentLanguage}
                            onChange={props.onChangeLanguage}
                            iconOnly={props.collapsedMenuLeft}
                            className="w100-percent" buttonClass="w100-percent pl-4" />
                    }
                    <Menu>
                        <SubMenu key="menu-footer"
                            title={
                                <div className="avatar">
                                    <Avatar size="medium"
                                        src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${dataUser && dataUser.avatarUrl ? dataUser.avatarUrl : "static-voucher.vinpearl.com/images/logo.png"}`}
                                        className={`mr-3`} />
                                    {!isMobile && !props.collapsedMenuLeft &&
                                        <EllipsisText
                                            title={getLocaleFullName(dataUser.firstname, dataUser.lastname)}
                                            content={getLocaleFullName(dataUser.firstname, dataUser.lastname)}
                                            maxContentWidth={80} />
                                    }
                                </div>
                            }>
                            <Menu.Item>
                                <Ripple rel="noopener noreferrer" onClick={props.onPressChangePassword}>
                                    <Icon type={'lock'} style={{ fontSize: '14px', marginRight: 10 }} />{i18n.t(`item.user.changePassword`)}
                                </Ripple>
                            </Menu.Item>
                            <Menu.Item>
                                <Ripple rel="noopener noreferrer" onClick={props.onPressLogout}>
                                    <Icon type={'logout'} style={{ fontSize: '14px', marginRight: 10 }} />{i18n.t(`logout`)}
                                </Ripple>
                            </Menu.Item>
                        </SubMenu>
                    </Menu>
                </div>
            }
        </div>
    )
};

const NavigationMobile = props => {

    return (
        <Drawer
            placement="left"
            disabled={true}
            closable={false}
            onClose={props.onClose}
            visible={isMobile && props.collapsedMenuLeft}
        >
            {
                props.children
            }
        </Drawer>
    )
};

Navigation.defaultProps = {
    onChangeLanguage: (lang) => { }
}

const mapStateToProps = state => {
    return {
        settingState: state.settingReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeContentLanguage: (language) => dispatch(action.Setting.changeContentLanguage(language))
    }
};

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Navigation)));
